import mediaTypeService from "../../services/mediaType";
const getDefaultState = () => {
    return {
        MediaType: {
            Id: 0,
            Entity: null,
            MasterMedia: null,
            MediaTypeName: null,
            SpectraCode: null,
            PrismaCode: null,
            ApplicableToFormTypes: null,
            DisplayOrder: null,
            UpdatedBy: null,
            CreatedBy: null,
        },
    };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
    MediaType: (state) => {
        return state.MediaType;
    }
};

// actions
const actions = {
    AddMediaType(st, data) {
        return mediaTypeService.AddMediaType(data, st.rootState.auth.idToken);
    },
    UpdateMediaType(st, { id, data }) {
        return mediaTypeService.UpdateMediaType(
            id,
            data,
            st.rootState.auth.idToken
        );
    },
    GetAllMediaTypes(st, data) {
        return mediaTypeService.GetAllMediaTypes(st.rootState.auth.idToken, data);
    },
    GetMediaTypes(st, entity, data) {
        return mediaTypeService.GetMediaTypes(entity, data, st.rootState.auth.idToken);
    },
    DeleteMediaType(st, id) {
        return mediaTypeService.DeleteMediaType(st.rootState.auth.idToken, id);
    },
};
// mutations
const mutations = {
    reset(st) {
        const s = getDefaultState();
        Object.keys(st).forEach((d) => {
            st[d] = s[d];
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};